export default "/_next/static/images/small_curved_arrow-bb5350c95dc7451d9f96b5d5cbafd907.gif";